// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1Xp92","header":"ReportDetails_header__2elYa","title":"ReportDetails_title__32n2L","left":"ReportDetails_left__e1xkN"};